import { useState, useEffect } from 'react';

const STORAGE_KEY = 'mfml_storage_consent_v1';

// First-visit local storage/cookie consent banner.
// MFML uses browser localStorage and sessionStorage only — no third-party ad cookies.
// This banner is shown once; dismissal is recorded in localStorage itself.
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) setVisible(true);
    } catch (_) {
      // If localStorage isn't accessible, don't show the banner
    }
  }, []);

  function handleAccept() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: Date.now() }));
    } catch (_) {}
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 8000,
      background: 'linear-gradient(0deg, rgba(10,8,6,0.98) 0%, rgba(14,10,8,0.95) 100%)',
      borderTop: '1px solid rgba(196,168,130,0.15)',
      padding: '16px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      flexWrap: 'wrap',
      backdropFilter: 'blur(8px)',
    }}>
      <p style={{
        margin: 0,
        fontSize: '12px',
        color: '#6a5f4f',
        lineHeight: '1.6',
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        maxWidth: '600px',
      }}>
        MFML uses browser local storage to keep you logged in and save your preferences.
        We do not use advertising cookies or sell your data.{' '}
        <a href="/privacy" style={{ color: '#8a7a65', textDecoration: 'underline', textUnderlineOffset: '2px' }}>
          Privacy Policy
        </a>
      </p>

      <button
        onClick={handleAccept}
        style={{
          flexShrink: 0,
          padding: '8px 20px',
          background: 'rgba(196,168,130,0.1)',
          border: '1px solid rgba(196,168,130,0.3)',
          borderRadius: '8px',
          color: '#c4a882',
          fontFamily: "'Cinzel', serif",
          fontSize: '11px',
          letterSpacing: '1.5px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Got It
      </button>
    </div>
  );
}
